export default __webpack_public_path__ + "static/media/minivan.fb87a1fa.webp";